import { render, staticRenderFns } from "./headerCover.vue?vue&type=template&id=5241a200&scoped=true&"
import script from "./headerCover.vue?vue&type=script&lang=js&"
export * from "./headerCover.vue?vue&type=script&lang=js&"
import style0 from "./headerCover.vue?vue&type=style&index=0&id=5241a200&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241a200",
  null
  
)

export default component.exports